export default "__VITE_ASSET__D_vL49XL__"